import { PropsWithChildren, createContext, useContext, useState, useRef, useEffect, useMemo } from 'react'
import Styles from './TabPanel.module.scss'
import { AriaLabelingProps } from '@react-types/shared'
import { Header } from './Header'

interface TabPanelContextValue {
  isScrolled: boolean
  setIsScrolled: (v: boolean) => void
}

const TabPanelContext = createContext<TabPanelContextValue>({ isScrolled: false, setIsScrolled: () => {} })

export const useTabPanelScrolled = () => useContext(TabPanelContext).isScrolled

const Root = (props: PropsWithChildren<AriaLabelingProps>) => {
  const [isScrolled, setIsScrolled] = useState(false)
  const value = useMemo(() => ({ isScrolled, setIsScrolled }), [isScrolled])
  return (
    <TabPanelContext.Provider value={value}>
      <div role="tabpanel" className={Styles.tabPanel} {...props} />
    </TabPanelContext.Provider>
  )
}

const Body = (props: PropsWithChildren) => {
  const { setIsScrolled } = useContext(TabPanelContext)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const onScroll = () => setIsScrolled(el.scrollTop > 0)
    onScroll()
    el.addEventListener('scroll', onScroll)
    return () => el.removeEventListener('scroll', onScroll)
  }, [setIsScrolled])

  return <div ref={ref} className={Styles.body} {...props} />
}

export const TabPanel = {
  Root,
  Header,
  Body,
}
